<script>
    import moment from 'moment/min/moment-with-locales'

    export default {
        name: 'ArticleService',
        data() {
            return {
                renewData: {
                    articleId: "",
                    articleType: "",
                }
            }
        },
        computed: {},
        methods: {
            // 檢查更新文章時間
            checkArticleRenewDate(updatedAt) {
                var result = false;
                var nowDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                var articleDate = moment(updatedAt).format('YYYY-MM-DD');
                if(nowDate >= articleDate ){
                    result = true;
                }
                return result;
            },
            // 更新文章上架時間
            renewArticle(id) {
                this.listLoading = true;
                this.renewData.articleId = id;
                this.FETCH({
                    key: 'RENEW_ARTICLE',
                    ...this.renewData
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleSearch)
                    }
                    if (!+(res || {}).code) {
                        this.$message(res.message);
                        this.handleSearch();
                    }else {
                        this.$message({
                            message: '更新失敗，請聯絡客服人為您處理。',
                            type: 'error'
                        });
                    }
                });


            }
        }
    }
</script>
